import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
/* eslint-disable react/no-array-index-key */
import React from 'react';
import { Card, Item, Grid, Header } from 'semantic-ui-react';
import { ChildrenPropType } from '../../services/proptypes';
import './ItemCollection.css';
var ItemCollection = /*#__PURE__*/function (_React$Component) {
  _inherits(ItemCollection, _React$Component);
  var _super = _createSuper(ItemCollection);
  function ItemCollection() {
    _classCallCheck(this, ItemCollection);
    return _super.apply(this, arguments);
  }
  _createClass(ItemCollection, [{
    key: "getItems",
    value: function getItems() {
      var _this$props = this.props,
        itemsPerRow = _this$props.itemsPerRow,
        onlyEvenRows = _this$props.onlyEvenRows,
        children = _this$props.children;
      if (onlyEvenRows && React.Children.count(children) >= itemsPerRow) {
        return React.Children.toArray(children).slice(0, Math.floor(React.Children.count(children) / itemsPerRow) * itemsPerRow);
      }
      return React.Children.toArray(children);
    }
  }, {
    key: "getHeaderStyle",
    value: function getHeaderStyle() {
      var collectionType = this.props.collectionType;
      if (collectionType === 'custom') return {
        marginLeft: '0.5em',
        marginRight: '1.5em'
      };
      return {};
    }
  }, {
    key: "renderGridCollection",
    value: function renderGridCollection() {
      var _this$props2 = this.props,
        itemsDivided = _this$props2.itemsDivided,
        itemsPerRow = _this$props2.itemsPerRow;
      return /*#__PURE__*/React.createElement(Grid, {
        stackable: true,
        columns: itemsPerRow,
        celled: itemsDivided && 'internally'
      }, this.getItems().map(function (item, index) {
        return /*#__PURE__*/React.createElement(Grid.Column, {
          key: index
        }, item);
      }));
    }
  }, {
    key: "renderItemCollection",
    value: function renderItemCollection() {
      var itemsDivided = this.props.itemsDivided;
      return /*#__PURE__*/React.createElement(Item.Group, {
        relaxed: true,
        divided: itemsDivided
      }, this.getItems());
    }
  }, {
    key: "renderCardCollection",
    value: function renderCardCollection() {
      var itemsPerRow = this.props.itemsPerRow;
      return /*#__PURE__*/React.createElement(Card.Group, {
        itemsPerRow: itemsPerRow,
        stackable: true
      }, this.getItems());
    }
  }, {
    key: "renderCollection",
    value: function renderCollection() {
      var collectionType = this.props.collectionType;
      if (collectionType === 'cards') return this.renderCardCollection();
      if (collectionType === 'items') return this.renderItemCollection();
      if (collectionType === 'custom') return this.renderGridCollection();
      return /*#__PURE__*/React.createElement("div", null);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        header = _this$props3.header,
        centerHeader = _this$props3.centerHeader,
        className = _this$props3.className;
      return /*#__PURE__*/React.createElement("div", {
        className: className
      }, header && /*#__PURE__*/React.createElement(Header, {
        as: "h1",
        textAlign: centerHeader ? 'center' : 'left',
        style: this.getHeaderStyle()
      }, header), this.renderCollection());
    }
  }]);
  return ItemCollection;
}(React.Component);
export { ItemCollection as default };
ItemCollection.defaultProps = {
  itemsPerRow: 3,
  itemsDivided: false,
  header: '',
  centerHeader: false,
  onlyEvenRows: false,
  className: ''
};
ItemCollection.propOptions = {};
ItemCollection.dataPropsMap = {};